import { DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Space, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import DoctorHeader from "../../../doctor/DoctorHeader";
import Sidebar from "../../Sidebar";
import moment from "moment";
import useToast from "../../../hooks/userToast";
import { searchnormal } from "../../imagepath";
import { Link } from "react-router-dom";
import useDebounce from "../../../hooks/useDebounce";
import useUser from "../../../hooks/useUser";
import excelicon from "../../../assets/img/excelicon.svg";

function Reports() {
  const { userToken } = useUser();
  const [reportData, setReportData] = useState();
  const { toastError, toastSuccess } = useToast();
  const [filterInput, setFilterInput] = useState("");
  const debouncedFilterInput = useDebounce(filterInput, 500);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { isSuperAdmin } = useUser();

  const [reportTotal, SetTotal] = useState();

  const fetchAllReports = async () => {
    const response = await apiClient.get(
      filterInput === ""
        ? `digitalLogs?page=${currentPage}&limit=${limit}`
        : `digitalLogs?search=${debouncedFilterInput}&page=${currentPage}&limit=${limit}`
    );

    setReportData(response?.data?.digitalLogs?.data);
    SetTotal(response?.data?.digitalLogs?.total);
  };

  useEffect(() => {
    fetchAllReports();
  }, [debouncedFilterInput, currentPage, limit]);

  const handleDownload = async () => {
    try {
      const response = await apiClient.get(
        `digitalLogs/download-excel-report?search=${filterInput}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`, // Include the token here
            "Content-Type": "application/json",
          },
          responseType: "blob", // Important for downloading files
        }
      );
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const blobUrl = window.URL.createObjectURL(blob); // Create a Blob URL

      // Create a temporary link element
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${new Date().toISOString().split("T")[0]}-reports.xlsx`; // Set the desired file name with today's date
      document.body.appendChild(a);
      a.click(); // Trigger the download
      document.body.removeChild(a);
      // Optionally revoke the Blob URL after some time to free memory
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 100);
    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await apiClient.delete(`digitalLogs/${id}`);
      await toastSuccess("Deleted Successfully!");
      await fetchAllReports();
    } catch (error) {
      toastError("Error Deleting Error", error);
      console.log(error);
    }
  };

  const columns = [
    {
      title: "Patient Name",
      dataIndex: "PatientName",
      key: "name",
      align: "center",
      width: "200",
      render: (text, record) => {
        return (
          <>
            <span style={{ textWrap: "wrap" }}>{record?.PatientName}</span>
          </>
        );
      },
    },
    {
      title: "Study Info ID",
      dataIndex: "id_study_info",
      key: "id_study_info",
      align: "center",
    },
    {
      title: "IP",
      dataIndex: "ip",
      key: "ip",
      align: "center",
    },
    {
      title: "Share Count",
      dataIndex: "share_count",
      key: "share_count",
      align: "center",
    },
    {
      title: "Share Time",
      dataIndex: "share_time",
      key: "share_time",
      align: "center",
      render: (text) => moment(text).format("YYYY-MM-DD | hh:mm A"),
    },
    {
      title: "Share Link",
      dataIndex: "share_link",
      key: "share_link",
      align: "center",
      render: (text, record) => {
        return (
          <>
            <span style={{ textWrap: "wrap" }}>{record?.share_link}</span>
          </>
        );
      },
    },

    {
      title: "Actions",
      dataIndex: "actions",
      width: "15%",
      render: (_, record) => (
        <Space style={{ padding: "5px" }}>
          <Tooltip title="Delete">
            <Popconfirm
              title="Are you sure you want to delete?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => {
                handleDelete(record?.id);
              }}
            >
              <Button>
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
      align: "center",
    },
  ];

  return (
    <>
      <DoctorHeader />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body cus_box">
                  <div className="card card-table show-entire mb-0">
                    <div className="page-table-header mb-2">
                      <div className="row align-items-center">
                        <div className="col">
                          <div className="doctor-table-blk">
                            <h2>Digital Sharing</h2>
                            <div
                              className="top-nav-search table-search-blk d-flex"
                              style={{ margin: "0px" }}
                            >
                              {isSuperAdmin && (
                                <div className="reports-download">
                                  <Button
                                    className="studies_expert"
                                    style={{
                                      fontSize: "medium",
                                      display: "flex",
                                      alignItems: "center",
                                      background: "#016fb9",
                                      color: "white",
                                      height: "32px",
                                      padding: "10px 5px !important",
                                    }}
                                    onClick={handleDownload}
                                  >
                                    Export
                                    <div className="px-1">
                                      <img
                                        height={"20px"}
                                        width={"20px"}
                                        src={excelicon}
                                      ></img>
                                    </div>
                                  </Button>
                                </div>
                              )}
                              <form>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search here"
                                  value={filterInput}
                                  onChange={(e) => {
                                    setFilterInput(() => e.target.value);
                                  }}
                                />
                                <Link className="btn">
                                  <img src={searchnormal} alt="#" />
                                </Link>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <Table
                      className="reports_table_border"
                        columns={columns}
                        dataSource={reportData}
                        rowKey={(record) => record.id}
                        scroll={{ x: 800 }}
                        bordered
                        pagination={{
                          total: reportTotal,
                          showTotal: (total, range) =>
                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                          onChange: (page) => {
                            setCurrentPage(page);
                          },
                          showSizeChanger: true,
                          onShowSizeChange: (current, size) => setLimit(size),
                          showQuickJumper: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Reports;
